// Mock данные для сайта ЛВК

export const products = [
  {
    id: 1,
    name: 'Хоккейное джерси Pro',
    category: 'jersey',
    description: 'Профессиональное хоккейное джерси с индивидуальным дизайном и логотипом команды. Изготовлено из высококачественной дышащей ткани с влагоотведением. Сублимационная печать обеспечивает яркость цветов на протяжении всего срока эксплуатации. Прочные усиленные швы выдерживают интенсивные тренировки и матчи. Доступны все размеры от детских до взрослых.',
    basePrice: 3500,
    image: 'https://images.unsplash.com/photo-1674571386896-54ea8a62b62d?w=800&q=80',
    alt: 'Хоккейное джерси Pro - профессиональная хоккейная форма на заказ СПб',
    features: ['Дышащая ткань с влагоотведением', 'Прочные усиленные швы', 'Яркая сублимационная печать', 'Индивидуальный дизайн и логотип']
  },
  {
    id: 2,
    name: 'Хоккейные гамаши',
    category: 'socks',
    description: 'Высокие профессиональные гамаши (рейтузы) с логотипом команды. Изготовлены из эластичного износостойкого материала, который обеспечивает идеальную посадку и комфорт во время игры. Яркая сублимационная печать не выцветает после стирок. Усиленные зоны в местах повышенной нагрузки. Подходят для детей, подростков и взрослых игроков.',
    basePrice: 800,
    image: 'https://images.pexels.com/photos/6847587/pexels-photo-6847587.jpeg?w=800&q=80',
    alt: 'Хоккейные гамаши - пошив на заказ с логотипом команды',
    features: ['Эластичный износостойкий материал', 'Яркие цвета не выцветают', 'Усиленные зоны нагрузки', 'Идеальная посадка']
  },
  {
    id: 3,
    name: 'Тренировочная форма',
    category: 'training',
    description: 'Комплект для тренировок в зале',
    basePrice: 2800,
    image: 'https://images.unsplash.com/photo-1697050267730-d7c89fac0d21?w=800&q=80',
    alt: 'Тренировочная форма для хоккея - спортивная одежда на заказ',
    features: ['Комфортная посадка', 'Влагоотведение', 'Фирменный стиль']
  },
  {
    id: 4,
    name: 'Чехлы для шорт',
    category: 'accessories',
    description: 'Защитные чехлы для хоккейных шорт',
    basePrice: 1200,
    image: 'https://images.unsplash.com/photo-1754583340212-5bddfda09f7e?w=800&q=80',
    alt: 'Чехлы для хоккейных шорт - защитная экипировка',
    features: ['Прочный материал', 'Удобная конструкция']
  },
  {
    id: 5,
    name: 'Бомбер команды',
    category: 'outerwear',
    description: 'Стильный бомбер с символикой команды',
    basePrice: 4500,
    image: 'https://images.pexels.com/photos/8972140/pexels-photo-8972140.jpeg?w=800&q=80',
    alt: 'Бомбер команды - куртка с вышивкой логотипа для хоккеистов',
    features: ['Теплый и легкий', 'Современный дизайн', 'Вышивка логотипа']
  },
  {
    id: 6,
    name: 'Куртка-парка',
    category: 'outerwear',
    description: 'Зимняя парка для болельщиков и команды',
    basePrice: 6500,
    image: 'https://images.unsplash.com/photo-1516226415502-d6624544376b?w=800&q=80',
    alt: 'Зимняя парка для хоккейной команды - теплая куртка с логотипом',
    features: ['Утеплитель', 'Водоотталкивающая ткань', 'Капюшон']
  },
  {
    id: 7,
    name: 'Жилетка команды',
    category: 'outerwear',
    description: 'Утепленная жилетка с логотипом',
    basePrice: 3200,
    image: 'https://images.unsplash.com/photo-1708477859742-7bce099bce11?w=800&q=80',
    alt: 'Жилетка команды - спортивная безрукавка с фирменным стилем',
    features: ['Легкая', 'Практичная', 'Удобные карманы']
  },
  {
    id: 8,
    name: 'Джерси для болельщиков',
    category: 'jersey',
    description: 'Реплика игрового джерси для фанатов',
    basePrice: 2500,
    image: 'https://images.unsplash.com/photo-1648312773792-3db3b560c793?w=800&q=80',
    alt: 'Джерси для болельщиков - фанатская хоккейная форма',
    features: ['Точная копия', 'Комфортная ткань', 'Доступная цена']
  }
];

// ============================================================================
// РЕЕСТР ВИДОВ СПОРТА
// ----------------------------------------------------------------------------
// Чтобы ДОБАВИТЬ новый вид спорта на сайт:
//   1. Добавьте сюда объект с уникальным id (совпадает с product.sport_type в БД).
//   2. Поставьте enabled: true — вид сразу появится в фильтрах и меню.
//   3. Добавьте его категории в массив `categories` ниже (sport_type: 'ваш_id').
//   4. Заведите товары в админке с этим sport_type.
// Каталог сам покажет переключатель видов спорта, когда включено больше одного.
// ============================================================================
export const sportTypes = [
  { id: 'hockey',     name: 'Хоккей',     icon: 'Snowflake',  enabled: true  },
  { id: 'football',   name: 'Футбол',     icon: 'Circle',     enabled: false },
  { id: 'basketball', name: 'Баскетбол',  icon: 'Dribbble',   enabled: false },
  { id: 'volleyball', name: 'Волейбол',   icon: 'Volleyball', enabled: false },
];

// Список id включённых видов спорта
export const enabledSportTypes = sportTypes.filter(s => s.enabled).map(s => s.id);

export const categories = [
  { id: 'all', name: 'Все товары', icon: 'Grid', sport_type: null },
  // Хоккей
  { id: 'jersey', name: 'Хоккейные джерси', icon: 'Shirt', sport_type: 'hockey' },
  { id: 'socks', name: 'Гамаши (хоккей)', icon: 'Gauge', sport_type: 'hockey' },
  { id: 'hockey-uniform', name: 'Хоккейная форма', icon: 'Shirt', sport_type: 'hockey' },
  // Универсальные / командные (sport_type: null — видны для всех видов спорта)
  { id: 'training', name: 'Тренировочная форма', icon: 'Dumbbell', sport_type: null },
  { id: 'outerwear', name: 'Верхняя одежда', icon: 'Wind', sport_type: null },
  { id: 'pants', name: 'Штаны и нашортники', icon: 'Scissors', sport_type: null },
  { id: 'casual', name: 'Повседневная одежда', icon: 'Package', sport_type: null },
  { id: 'accessories', name: 'Аксессуары', icon: 'Package', sport_type: null },
  // ── Другие виды спорта: раскомментируйте + включите вид в sportTypes выше ──
  // { id: 'football-jersey', name: 'Футбольные джерси', icon: 'Shirt', sport_type: 'football' },
  // { id: 'basketball-jersey', name: 'Баскетбольные майки', icon: 'Shirt', sport_type: 'basketball' },
  // { id: 'volleyball-jersey', name: 'Волейбольные майки', icon: 'Shirt', sport_type: 'volleyball' },
];

export const portfolio = [
  {
    id: 1,
    teamName: 'Юниор СПб',
    category: 'Детская команда',
    description: 'Полный комплект формы для детской хоккейной команды',
    items: ['Джерси', 'Гамаши', 'Тренировочная форма'],
    image: 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="800" height="600"%3E%3Crect width="800" height="600" fill="%232563eb"/%3E%3Ctext x="50%25" y="50%25" font-size="32" fill="white" text-anchor="middle" dy=".3em" font-family="Arial"%3EЮниор СПб%3C/text%3E%3C/svg%3E',
    year: '2024'
  },
  {
    id: 2,
    teamName: 'Ветераны Невы',
    category: 'Взрослая команда',
    description: 'Игровая и тренировочная форма для любительской команды',
    items: ['Джерси домашнее', 'Джерси гостевое', 'Парки'],
    image: 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="800" height="600"%3E%3Crect width="800" height="600" fill="%231e40af"/%3E%3Ctext x="50%25" y="50%25" font-size="32" fill="white" text-anchor="middle" dy=".3em" font-family="Arial"%3EВетераны Невы%3C/text%3E%3C/svg%3E',
    year: '2024'
  },
  {
    id: 3,
    teamName: 'Фан-клуб Зенит',
    category: 'Болельщики',
    description: 'Фирменная одежда для фан-клуба',
    items: ['Бомберы', 'Жилетки', 'Шарфы'],
    image: 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="800" height="600"%3E%3Crect width="800" height="600" fill="%23dc2626"/%3E%3Ctext x="50%25" y="50%25" font-size="32" fill="white" text-anchor="middle" dy=".3em" font-family="Arial"%3EФан-клуб Зенит%3C/text%3E%3C/svg%3E',
    year: '2023'
  },
  {
    id: 4,
    teamName: 'Родительский клуб',
    category: 'Родители',
    description: 'Единая форма для родителей юных хоккеистов',
    items: ['Толстовки', 'Бейсболки', 'Шарфы'],
    image: 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="800" height="600"%3E%3Crect width="800" height="600" fill="%23374151"/%3E%3Ctext x="50%25" y="50%25" font-size="32" fill="white" text-anchor="middle" dy=".3em" font-family="Arial"%3EРодительский клуб%3C/text%3E%3C/svg%3E',
    year: '2024'
  }
];

export const companyInfo = {
  name: 'AVK SPORT',
  fullName: 'AVK SPORT - Производство спортивной формы',
  description: 'Профессиональное производство спортивной формы для хоккея, футбола, баскетбола и волейбола. Верхняя одежда и экипировка для команд любого уровня',
  address: 'Санкт-Петербург, пр. Ветеранов 140 литГ',
  phone: '+7 (812) 317-73-19',
  email: 'zakaz@avk-pro.ru',
  logo: '/logo.png',
  workHours: 'Пн-Пт: 10:00-19:00',
  minOrder: 'Минимальная партия заказа - от 10 штук'
};

export const advantages = [
  {
    title: 'Собственное производство',
    description: 'Контролируем качество на всех этапах',
    icon: 'Factory'
  },
  {
    title: 'Быстрые сроки',
    description: 'Изготовление заказа от 14 дней',
    icon: 'Zap'
  },
  {
    title: 'Любой дизайн',
    description: 'Реализуем самые смелые идеи',
    icon: 'Palette'
  },
  {
    title: 'Опт и розница',
    description: 'Работаем с заказами от 10 штук',
    icon: 'Users'
  }
];

export const reviews = [
  {
    id: 1,
    author: 'Дмитрий Соколов',
    role: 'Тренер ДЮСШ',
    text: 'Заказывали форму для детской команды. Качество отличное, дети в восторге! Сроки соблюдены, цены адекватные.',
    rating: 5,
    date: '2024-01-15'
  },
  {
    id: 2,
    author: 'Анна Петрова',
    role: 'Представитель родительского комитета',
    text: 'Сделали бомберы для родителей нашей команды. Все очень довольны, качество на высоте!',
    rating: 5,
    date: '2024-02-03'
  },
  {
    id: 3,
    author: 'Игорь Васильев',
    role: 'Капитан любительской команды',
    text: 'Второй раз заказываем у ЛВК. Профессиональный подход, помогли с дизайном. Рекомендуем!',
    rating: 5,
    date: '2024-01-28'
  },
  {
    id: 4,
    author: 'Сергей Михайлов',
    role: 'Руководитель хоккейного клуба',
    text: 'Отличная работа!',
    rating: 5,
    date: '2024-03-10'
  },
  {
    id: 5,
    author: 'Екатерина Смирнова',
    role: 'Организатор турниров',
    text: 'Заказывали форму для турнира. Все участники были в восторге от качества и дизайна. Быстрая доставка, отличное обслуживание. Спасибо команде!',
    rating: 5,
    date: '2024-02-20'
  },
  {
    id: 6,
    author: 'Алексей Новиков',
    role: 'Игрок',
    text: 'Лучшая форма, которую я носил. Удобная и стильная.',
    rating: 5,
    date: '2024-03-05'
  },
  {
    id: 7,
    author: 'Ольга Волкова',
    role: 'Мама юного хоккеиста',
    text: 'Очень довольны! Форма отлично сидит, качество материалов превосходное. Сын в восторге.',
    rating: 5,
    date: '2024-01-22'
  },
  {
    id: 8,
    author: 'Павел Кузнецов',
    role: 'Тренер взрослой команды',
    text: 'Работаем с AVK SPORT уже третий сезон. Всегда высокое качество, индивидуальный подход к каждому заказу, помощь с дизайном. Рекомендуем всем командам!',
    rating: 5,
    date: '2024-02-15'
  },
  {
    id: 9,
    author: 'Мария Лебедева',
    role: 'Администратор клуба',
    text: 'Профессионально и в срок!',
    rating: 5,
    date: '2024-03-01'
  },
  {
    id: 10,
    author: 'Виктор Романов',
    role: 'Капитан команды ветеранов',
    text: 'Заказали полный комплект формы для нашей ветеранской команды. Все идеально подошло, качество на высшем уровне.',
    rating: 5,
    date: '2024-01-30'
  }
];
